module.exports = __webpack_public_path__ + "static/flags/NI-8313e478754f0d459aff618a07878876.gif";